/**
 * /javno/promet/<app public_id> entry — the public page »Promet po conah« (#867).
 * All logic lives in javno/PublicPrometPage.ts (DOM + map) and
 * javno/publicPrometPageModel.ts (pure, tested).
 */
import './javno/javno-promet.css';
import { DeviceDetector } from './utils/DeviceDetector.js';
import { PublicPrometPage } from './javno/PublicPrometPage.js';

DeviceDetector.initialize();
void new PublicPrometPage().start();
